<template>
  <v-overlay :opacity="0.6" v-model="show" z-index="6">
    <v-dialog
      v-model="show"
      hide-overlay
      @click:outside="doCloseConfirm"
      :persistent="true"
    >
      <div class="py-5 px-8 white" id="applicant-dialog">
        <div role="button" class="close" @click="doCloseConfirm">&times;</div>
        <div
          class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
        >
          {{ $t("applicant_title") }}
        </div>
        <template v-if="(isEdit && session && tickets.length) || !isEdit">
          <v-form
            ref="applicantForm"
            v-model="formValid"
            fast-fail
            @submit.prevent
          >
            <div class="applicant-sections">
              <!-- 基本資料 -->
              <div class="applicant-form-block">
                <v-row>
                  <!-- Nationality Type Selection (First step) -->
                  <v-col
                    cols="12"
                    v-if="!!session.applicants.properties.nationality"
                  >
                    <v-autocomplete
                      v-model="form.nationality"
                      :items="nationalitySelectableOptions"
                      item-text="text"
                      item-value="value"
                      :disabled="
                        isEdit &&
                        !session.applicants.properties.nationality.editable
                      "
                      :rules="
                        session.applicants.properties.nationality.required
                          ? [isRequired]
                          : []
                      "
                      :label="$t('applicant_nationality_label')"
                      :menu-props="{ offsetY: true }"
                      hide-details
                      @change="handleNationalityChange"
                    ></v-autocomplete>
                  </v-col>

                  <template v-if="shouldShowApplicantDetailFields">
                    <template v-if="session.applicants.properties.identityName">
                      <v-col
                        cols="12"
                        id="identityName"
                        v-if="!!session.applicants.properties.identityName"
                      >
                        <v-text-field
                          :label="nameLabel"
                          :hint="nameHintText"
                          persistent-hint
                          :required="
                            session.applicants.properties.identityName.required
                          "
                          :disabled="
                            (!!session.applicants.properties.nationality &&
                              !nationalityType) ||
                            (isEdit &&
                              !session.applicants.properties.identityName
                                .editable)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.identityName.editable
                              ? 'mdi-lock '
                              : ''
                          "
                          v-model="form.identityName"
                          @change="(v) => (form.identityName = v)"
                          :rules="identityNameRules"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        id="identityNumber"
                        v-if="!!session.applicants.properties.identityNumber"
                      >
                        <v-text-field
                          ref="idNumberInput"
                          :label="identityNumberLabel"
                          :required="
                            session.applicants.properties.identityNumber
                              .required
                          "
                          :disabled="
                            (!!session.applicants.properties.nationality &&
                              !nationalityType) ||
                            (isEdit &&
                              !session.applicants.properties.identityNumber
                                .editable)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.identityNumber
                              .editable
                              ? 'mdi-lock '
                              : ''
                          "
                          v-model="form.identityNumber"
                          :rules="identityNumberRules"
                          @keyup="keyupSetting"
                          @input="updateIdentityNumber"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col
                        cols="12"
                        id="firstName"
                        v-if="!!session.applicants.properties.firstName"
                      >
                        <v-text-field
                          :label="$t('applicant_first_name_label')"
                          :hint="nameHintText"
                          persistent-hint
                          :required="
                            session.applicants.properties.firstName.required
                          "
                          :disabled="
                            (!!session.applicants.properties.nationality &&
                              !nationalityType) ||
                            (isEdit &&
                              !session.applicants.properties.firstName.editable)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.firstName.editable
                              ? 'mdi-lock '
                              : ''
                          "
                          v-model="form.firstName"
                          @change="(v) => (form.firstName = v)"
                          :rules="firstNameRules"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        id="lastName"
                        v-if="!!session.applicants.properties.lastName"
                      >
                        <v-text-field
                          :label="$t('applicant_last_name_label')"
                          :required="
                            session.applicants.properties.lastName.required
                          "
                          :disabled="
                            (!!session.applicants.properties.nationality &&
                              !nationalityType) ||
                            (isEdit &&
                              !session.applicants.properties.lastName.editable)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.lastName.editable
                              ? 'mdi-lock '
                              : ''
                          "
                          v-model="form.lastName"
                          @change="(v) => (form.lastName = v)"
                          :rules="lastNameRules"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        id="identityNumber"
                        v-if="!!session.applicants.properties.identityNumber"
                      >
                        <v-text-field
                          ref="idNumberInput"
                          :label="identityNumberLabel"
                          :required="
                            session.applicants.properties.identityNumber
                              .required
                          "
                          :disabled="
                            (!!session.applicants.properties.nationality &&
                              !nationalityType) ||
                            (isEdit &&
                              !session.applicants.properties.identityNumber
                                .editable)
                          "
                          :append-icon="
                            isEdit &&
                            !session.applicants.properties.identityNumber
                              .editable
                              ? 'mdi-lock '
                              : ''
                          "
                          v-model="form.identityNumber"
                          :rules="identityNumberRules"
                          @input="updateIdentityNumber"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <v-col
                      cols="12"
                      id="birthday"
                      v-if="!!session.applicants.properties.birthday"
                    >
                      <div class="d-flex align-center">
                        <v-menu
                          ref="birthdayMenu"
                          :close-on-content-click="false"
                          :return-value.sync="form.birthday"
                          transition="scale-transition"
                          :disabled="
                            isEdit &&
                            !session.applicants.properties.birthday.editable
                          "
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="form.birthday"
                              :rules="
                                session.applicants.properties.birthday.required
                                  ? [isRequired]
                                  : []
                              "
                              :required="
                                session.applicants.properties.birthday.required
                              "
                              :label="$t('applicant_birthday_label')"
                              :disabled="
                                isEdit &&
                                !session.applicants.properties.birthday.editable
                              "
                              :append-icon="
                                isEdit &&
                                !session.applicants.properties.birthday.editable
                                  ? 'mdi-lock '
                                  : 'mdi-calendar'
                              "
                              color="primary"
                              hide-details=""
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="form.birthday"
                            no-title
                            scrollable
                            color="primary"
                            @change="$refs.birthdayMenu.save(form.birthday)"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      id="age"
                      v-if="!!session.applicants.properties.age"
                    >
                      <v-text-field
                        :label="$t('applicant_age_label')"
                        type="tel"
                        v-model="form.age"
                        :required="session.applicants.properties.age.required"
                        :rules="
                          session.applicants.properties.age.required
                            ? [isRequired, isNumber]
                            : [isNumber]
                        "
                        :disabled="
                          isEdit && !session.applicants.properties.age.editable
                        "
                        :append-icon="
                          isEdit && !session.applicants.properties.age.editable
                            ? 'mdi-lock '
                            : ''
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      id="gender"
                      v-if="!!session.applicants.properties.gender"
                    >
                      <v-radio-group
                        v-model="form.gender"
                        row
                        class="mt-0"
                        :disabled="
                          isEdit &&
                          !session.applicants.properties.gender.editable
                        "
                      >
                        <template v-slot:label>
                          <div>{{ $t("applicant_gender_label") }}</div>
                        </template>
                        <v-radio
                          :label="$t('applicant_gender_male')"
                          value="M"
                        ></v-radio>
                        <v-radio
                          :label="$t('applicant_gender_female')"
                          value="F"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col
                      cols="12"
                      id="phoneNumber"
                      v-if="!!session.applicants.properties.phoneNumber"
                    >
                      <div class="d-none">
                        <v-text-field
                          v-model="form.tempphoneNumber"
                          :required="
                            session.applicants.properties.phoneNumber.required
                          "
                          :rules="
                            session.applicants.properties.phoneNumber.required
                              ? [isRequired]
                              : []
                          "
                        />
                      </div>
                      <VuePhoneNumberInput
                        :class="!phoneValid ? 'error--text' : ''"
                        error-color="#ff0032"
                        :no-flags="true"
                        ref="phoneInputRef"
                        :disabled="
                          isEdit &&
                          !session.applicants.properties.phoneNumber.editable
                        "
                        :error="
                          session.applicants.properties.phoneNumber.required &&
                          (form.tempphoneNumber === '' || !form.tempphoneNumber)
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties.phoneNumber.editable
                            ? 'mdi-lock '
                            : ''
                        "
                        :translations="{
                          countrySelectorLabel: $t('country_code'),
                          phoneNumberLabel: $t('login_phone_field'),
                        }"
                        :required="
                          session.applicants.properties.phoneNumber.required
                        "
                        @update="
                          (obj) => phoneNumberUpdate('tempphoneNumber', obj)
                        "
                        :default-country-code="form.tempphoneCountry || ''"
                        v-model="form.tempphoneNumber"
                      />
                      <v-icon
                        class="is-phone-lock"
                        v-if="
                          isEdit &&
                          !session.applicants.properties.phoneNumber.editable
                        "
                        >mdi-lock</v-icon
                      >
                      <div
                        v-if="
                          session.applicants.properties.phoneNumber.required &&
                          (form.tempphoneNumber === '' || !form.tempphoneNumber)
                        "
                        class="v-messages error--text mt-1"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            {{
                              $t(
                                !form.tempphoneNumber ||
                                  form.tempphoneNumber === ""
                                  ? "form_required"
                                  : "applicant_phone_invalid_text"
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      id="address"
                      v-if="!!session.applicants.properties.address"
                    >
                      <v-text-field
                        :label="$t('applicant_address_label')"
                        v-model="form.address"
                        :rules="
                          session.applicants.properties.address.required
                            ? [isRequired]
                            : []
                        "
                        :disabled="
                          isEdit &&
                          !session.applicants.properties.address.editable
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties.address.editable
                            ? 'mdi-lock '
                            : ''
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      id="email"
                      v-if="!!session.applicants.properties.email"
                    >
                      <v-text-field
                        :label="$t('applicant_email_label')"
                        type="email"
                        v-model="form.email"
                        :rules="
                          session.applicants.properties.email.required
                            ? [isRequired, isEmail]
                            : []
                        "
                        :disabled="
                          isEdit &&
                          !session.applicants.properties.email.editable
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties.email.editable
                            ? 'mdi-lock '
                            : ''
                        "
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      id="emergencyContactPerson"
                      v-if="
                        session.applicants.properties.emergencyContactPerson
                      "
                    >
                      <v-text-field
                        :label="$t('applicant_emergency_contact_person_label')"
                        v-model="form.emergencyContactPerson"
                        :required="
                          session.applicants.properties.emergencyContactPerson
                            .required
                        "
                        :rules="
                          session.applicants.properties.emergencyContactPerson
                            .required
                            ? [isRequired]
                            : []
                        "
                        :disabled="
                          isEdit &&
                          !session.applicants.properties.emergencyContactPerson
                            .editable
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties.emergencyContactPerson
                            .editable
                            ? 'mdi-lock '
                            : ''
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      id="emergencyContactRelation"
                      v-if="
                        !!session.applicants.properties.emergencyContactRelation
                      "
                    >
                      <v-text-field
                        :label="
                          $t('applicant_emergency_contact_relation_label')
                        "
                        v-model="form.emergencyContactRelation"
                        :required="
                          session.applicants.properties.emergencyContactRelation
                            .required
                        "
                        :rules="
                          session.applicants.properties.emergencyContactRelation
                            .required
                            ? [isRequired]
                            : []
                        "
                        :disabled="
                          isEdit &&
                          !session.applicants.properties
                            .emergencyContactRelation.editable
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties
                            .emergencyContactRelation.editable
                            ? 'mdi-lock '
                            : ''
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      id="emergencyContactPhoneNumber"
                      v-if="
                        !!session.applicants.properties
                          .emergencyContactPhoneNumber
                      "
                    >
                      <div class="d-none">
                        <v-text-field
                          v-model="form.tempemergencyContactPhoneNumber"
                          :required="
                            session.applicants.properties
                              .emergencyContactPhoneNumber.required
                          "
                          :rules="
                            session.applicants.properties
                              .emergencyContactPhoneNumber.required
                              ? [isRequired]
                              : []
                          "
                        />
                      </div>
                      <VuePhoneNumberInput
                        :class="!emergencyPhoneValid ? 'error--text' : ''"
                        :no-flags="true"
                        ref="emergencyPhoneInputRef"
                        :disabled="
                          isEdit &&
                          !session.applicants.properties
                            .emergencyContactPhoneNumber.editable
                        "
                        :rules="
                          session.applicants.properties
                            .emergencyContactPhoneNumber.required
                            ? [isRequired]
                            : []
                        "
                        :append-icon="
                          isEdit &&
                          !session.applicants.properties
                            .emergencyContactPhoneNumber.editable
                            ? 'mdi-lock '
                            : ''
                        "
                        @update="
                          (obj) =>
                            phoneNumberUpdate(
                              'tempemergencyContactPhoneNumber',
                              obj
                            )
                        "
                        :error-color="'#ff0032'"
                        :translations="{
                          countrySelectorLabel: $t('country_code'),
                          phoneNumberLabel: $t(
                            'applicant_emergency_contact_phone_label'
                          ),
                          example: $t('phone_number_example'),
                        }"
                        :required="
                          session.applicants.properties
                            .emergencyContactPhoneNumber.required
                        "
                        :default-country-code="
                          form.emergencyContactPhoneCountry || ''
                        "
                        v-model="form.tempemergencyContactPhoneNumber"
                      />
                      <div
                        v-if="!emergencyPhoneValid"
                        class="v-messages error--text mt-1"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            {{
                              $t(
                                form.emergencyContactPhoneNumber === ""
                                  ? "form_required"
                                  : "applicant_phone_invalid_text"
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <template v-for="(field, i) in customFields">
                      <v-col cols="12" class="pt-2">
                        <v-text-field
                          :id="field.name"
                          :label="field.label"
                          :v-model="form[field.name]"
                          :value="field.value"
                          @change="
                            (value) => customFieldChange(field.name, value)
                          "
                          :required="
                            session.applicants.properties[field.name].required
                          "
                          :rules="
                            session.applicants.properties[field.name].required
                              ? [isRequired]
                              : []
                          "
                          :disabled="isEdit && !field.editable"
                          :append-icon="
                            isEdit && !field.editable ? 'mdi-lock ' : ''
                          "
                        ></v-text-field>
                      </v-col>
                    </template>

                    <template v-if="!!session.applicants.properties.shirtSize">
                      <v-col cols="12">
                        <v-radio-group
                          v-model="form.shirtSize"
                          row
                          :required="
                            session.applicants.properties.shirtSize.required
                          "
                          :rules="
                            session.applicants.properties.shirtSize.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                            !session.applicants.properties.shirtSize.editable
                          "
                        >
                          <template v-slot:label>
                            <div>{{ $t("applicant_shirt_size_label") }}</div>
                          </template>
                          <v-radio label="XS" value="XS"></v-radio>
                          <v-radio label="S" value="S"></v-radio>
                          <v-radio label="M" value="M"></v-radio>
                          <v-radio label="L" value="L"></v-radio>
                          <v-radio label="XL" value="XL"></v-radio>
                          <v-radio label="2XL" value="2XL"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </template>

                    <template v-if="!!session.applicants.properties.worldgymId">
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.worldgymId"
                          :label="$t('applicant_world_gym_id_field')"
                          :required="
                            session.applicants.properties.worldgymId.required
                          "
                          :rules="
                            session.applicants.properties.worldgymId.required
                              ? [isRequired]
                              : []
                          "
                          :disabled="
                            isEdit &&
                            !session.applicants.properties.worldgymId.editable
                          "
                        />
                      </v-col>
                    </template>
                  </template>
                </v-row>
              </div>
            </div>
            <div class="expansion-action mt-6">
              <v-btn
                class="nextBtn"
                :disabled="isInvalid || (isEdit && !hasDiff && !customDiff)"
                :class="{
                  disabledBtn: isInvalid || (isEdit && !hasDiff && !customDiff),
                }"
                depressed
                :x-large="!$vuetify.breakpoint.xs"
                @click="submit()"
                >{{ $t("applicant_form_complete") }}</v-btn
              >
            </div>
          </v-form>
        </template>
      </div>
    </v-dialog>
  </v-overlay>
</template>

<script>
import DatePicker from "@/views/auth/components/DatePicker.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import parsePhoneNumber from "libphonenumber-js";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { mapActions, mapGetters } from "vuex";
import TM from "@/api/ticket-management";
import { countryList } from "@/vendor/country";

const TAIWAN_CODE = "TW";
const TAIWAN_LABEL = "Taiwan (台灣)";
const OVERSEAS = "OVERSEAS";
const NATIONALITY_DEPENDENT_FIELDS = [
  "identityName",
  "firstName",
  "lastName",
  "identityNumber",
];

function normalizeNationalityValue(value) {
  if (!value) return "";
  if (value === OVERSEAS) return OVERSEAS;
  if (value === TAIWAN_CODE || value === TAIWAN_LABEL) return TAIWAN_CODE;

  const byIso2 = countryList.find((country) => country.iso2 === value);
  if (byIso2) return byIso2.iso2;

  const byLabel = countryList.find((country) => country.name === value);
  if (byLabel) return byLabel.iso2;

  return value;
}

function createEmptyForm() {
  return {
    tempphoneCountry: "",
    tempemergencyContactPhoneCountry: "",
    tempphoneNumber: "",
    tempemergencyContactPhoneNumber: "",
    ticket: "",
    firstName: "",
    lastName: "",
    identityName: "",
    identityNumber: "",
    nationality: "",
    birthday: "",
    age: "",
    gender: "",
    phoneNumber: "",
    address: "",
    email: "",
    emergencyContactPerson: "",
    emergencyContactRelation: "",
    emergencyContactPhoneNumber: "",
    shirtSize: "",
    worldgymId: "",
  };
}

function hydrateFormWithPhones(base, source) {
  let form = { ...base };
  if (source && source.phoneNumber) {
    const phoneNumber = parsePhoneNumber(source.phoneNumber);
    form = {
      ...form,
      tempphoneNumber: phoneNumber.nationalNumber,
      tempphoneCountry: phoneNumber.country,
    };
  }
  if (source && source.emergencyContactPhoneNumber) {
    const emphone = parsePhoneNumber(source.emergencyContactPhoneNumber);
    form = {
      ...form,
      tempemergencyContactPhoneNumber: emphone.nationalNumber,
      tempemergencyContactPhoneCountry: emphone.country,
    };
  }
  return form;
}

function normalizeApplicant(applicant) {
  return applicant || {};
}

export default {
  components: {
    DatePicker,
    VuePhoneNumberInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    selectedIdx: {
      type: Number,
      default: -1,
    },
    applicant: {
      type: Object,
      default: () => ({}),
    },
    applicants: {
      type: Array,
      default: () => [],
    },
    tickets: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      nationalityType: null,
      customDiff: false,
      isLockAll: true,
      customFields: [],
      appliData: normalizeApplicant(this.applicant),
      items: this.tickets.map((t) => t.name),
      isConfirmDialogShow: false,
      confirmToClose: false,
      ticketFormValid: false,
      formValid: true,
      phoneValid: true,
      emergencyPhoneValid: true,
      form: createEmptyForm(),
      products: [],
      ticketOption: [],
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(newVal, val) {
        if (newVal) {
          this.appliData = normalizeApplicant(this.applicant);
          this.form = createEmptyForm();
          this.initCustomFields(this.appliData);
          const form = hydrateFormWithPhones(this.appliData, this.appliData);
          this.setForm(form);
          this.initNationalityType();
          this.validateAllForms();
          this.$forceUpdate();
        } else {
          this.resetCustomState();
          this.form = createEmptyForm();
          this.nationalityType = null;
        }
        this.$forceUpdate();
      },
    },
    "form.nationality": {
      handler(val) {
        this.nationalityType = val || null;
      },
      immediate: true,
    },
    form: {
      immediate: true,
      deep: true,
      async handler(v, o) {
        if (
          this.show &&
          this.$refs.applicantForm &&
          typeof this.$refs.applicantForm.validate === "function"
        ) {
          await this.$nextTick();
          this.$refs.applicantForm.validate();
        }
      },
    },
    appliData: {
      immediate: true,
      deep: true,
      handler(newVal, val) {
        const newIdx = newVal ? newVal.index : null;
        const oldIdx = val ? val.index : null;
        if (newIdx === oldIdx) return;

        this.form = createEmptyForm();
        this.initCustomFields(newVal);

        const form = hydrateFormWithPhones(newVal, newVal);
        this.setForm(form);
        this.initNationalityType();
        this.$forceUpdate();
      },
    },
  },
  computed: {
    ...mapGetters({
      session: "session/sessionInfo",
      reserveResponse: "order/reserveResponse",
      sessionInfo: "session/sessionInfo",
    }),
    hasEmpty() {
      const props = this.session.applicants.properties;
      return Object.keys(this.form).some(
        (key) =>
          !key.startsWith("temp") &&
          key !== "ticket" &&
          Object.prototype.hasOwnProperty.call(props, key) &&
          this.form[key] === ""
      );
    },
    hasDiff() {
      if (!this.isEdit) return false;
      return Object.keys(this.form).some(
        (key) =>
          !key.startsWith("temp") &&
          key !== "ticket" &&
          this.form[key] !== this.applicant[key]
      );
    },
    hasUserInfo() {
      if (!this.session || !this.session.applicants) return false;
      const userInfoKeys = [
        "identityName",
        "firstName",
        "lastName",
        "identityNumber",
        "nationality",
        "birthday",
        "age",
        "gender",
        "phoneNumber",
        "address",
        "email",
      ];
      return Object.keys(this.session.applicants.properties).some((i) =>
        userInfoKeys.includes(i)
      );
    },
    hasEditable() {
      const props = this.sessionInfo.applicants.properties;
      return Object.keys(props).some((key) => props[key].editable);
    },
    requiredFieldKeys() {
      const props = this.session?.applicants?.properties || {};
      return Object.keys(props).filter(
        (key) => props[key]?.required && this.isFieldVisible(key)
      );
    },
    isInvalid() {
      const allFormsValid = this.formValid;
      const hasMissingRequired = this.requiredFieldKeys.some((key) =>
        this.isFieldValueInvalid(key)
      );
      return !allFormsValid || hasMissingRequired;
    },
    allowedCountries() {
      return this.session?.applicants?.properties?.nationality?.enum || null;
    },
    hasSpecificOverseasCountries() {
      return !!this.restrictedNationalityCountries;
    },
    restrictedNationalityCountries() {
      const raw = this.allowedCountries || [];
      if (!raw.length) return null;

      const normalized = raw.map((value) => normalizeNationalityValue(value));

      const onlyTaiwan =
        normalized.length === 1 && normalized[0] === TAIWAN_CODE;
      const specificCountries = normalized.filter(
        (code) => code !== TAIWAN_CODE && code !== OVERSEAS
      );

      if (onlyTaiwan) {
        return [TAIWAN_CODE];
      }

      if (!specificCountries.length) {
        return null;
      }

      return [
        ...(normalized.includes(TAIWAN_CODE) ? [TAIWAN_CODE] : []),
        ...specificCountries,
      ].filter((value, index, list) => list.indexOf(value) === index);
    },
    shouldShowApplicantDetailFields() {
      if (!this.session?.applicants?.properties?.nationality) return true;
      return !!this.nationalityType;
    },
    nationalityOptions() {
      if (this.hasSpecificOverseasCountries) {
        return (this.restrictedNationalityCountries || []).map((code) => ({
          text: this.getCountryLabel(code),
          value: this.getCountryLabel(code),
        }));
      }
      return countryList.map((country) => ({
        text: this.getCountryLabel(country.iso2),
        value: this.getCountryLabel(country.iso2),
      }));
    },
    nationalitySelectableOptions() {
      return this.nationalityOptions;
    },
    nationalityCategory() {
      const normalized = normalizeNationalityValue(this.form.nationality);
      if (normalized === TAIWAN_CODE) {
        return TAIWAN_LABEL;
      }
      if (normalized) {
        return OVERSEAS;
      }
      return null;
    },
    nameLabel() {
      if (this.session?.applicants?.properties?.nationality) {
        if (this.nationalityCategory === OVERSEAS) {
          return this.$t("applicant_name_label_overseas");
        }
      }
      return this.$t("applicant_name_label_default");
    },
    nameHintText() {
      if (this.session?.applicants?.properties?.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return this.$t("applicant_validation_tw_name");
        }
        if (this.nationalityCategory === OVERSEAS) {
          const foreign =
            this.session.applicants.properties.identityNumber?.foreign;
          if (foreign === "RESIDENCE_PERMIT") {
            return this.$t("applicant_validation_residence_permit_name");
          }
          return this.$t("applicant_validation_passport_name");
        }
      }

      const foreign =
        this.session?.applicants?.properties?.identityNumber?.foreign;
      if (foreign === "RESIDENCE_PERMIT") {
        return this.$t("applicant_validation_residence_permit_name");
      }
      return this.$t("applicant_validation_passport_name");
    },
    identityNumberLabel() {
      if (this.session?.applicants?.properties?.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return this.$t("applicant_identity_number_label_tw");
        } else if (this.nationalityCategory === OVERSEAS) {
          const foreign =
            this.session.applicants.properties.identityNumber?.foreign;
          if (foreign === "RESIDENCE_PERMIT") {
            return this.$t("applicant_identity_number_label_residence_permit");
          }
          return this.$t("applicant_identity_number_label_passport");
        }
      }
      if (this.session?.applicants?.properties?.identityName) {
        return this.$t("applicant_identity_number_label_passport_fallback");
      }
      return this.$t("applicant_identity_number_label_external_id");
    },
    identityNameRules() {
      if (!this.session?.applicants?.properties?.identityName?.required)
        return [];
      if (this.session.applicants.properties.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return [this.isRequired, this.onlyChWord];
        } else if (this.nationalityCategory === OVERSEAS) {
          return [this.isRequired, this.onlyEnNumSpace];
        }
      }
      return [this.isRequired, this.onlyEnChWord];
    },
    firstNameRules() {
      if (!this.session?.applicants?.properties?.firstName?.required) return [];
      if (this.session.applicants.properties.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return [this.isRequired, this.onlyChWord];
        } else if (this.nationalityCategory === OVERSEAS) {
          return [this.isRequired, this.onlyEnNumSpace];
        }
      }
      return [this.isRequired, this.onlyEnChWord];
    },
    lastNameRules() {
      if (!this.session?.applicants?.properties?.lastName?.required) return [];
      if (this.session.applicants.properties.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return [this.isRequired, this.onlyChWord];
        } else if (this.nationalityCategory === OVERSEAS) {
          return [this.isRequired, this.onlyEnNumSpace];
        }
      }
      return [this.isRequired, this.onlyEnChWord];
    },
    identityNumberRules() {
      if (!this.session?.applicants?.properties?.identityNumber?.required)
        return [];
      if (this.session.applicants.properties.nationality) {
        if (this.nationalityCategory === TAIWAN_LABEL) {
          return [this.isRequired, this.idNumberValid, this.sameId];
        } else if (this.nationalityCategory === OVERSEAS) {
          const foreign =
            this.session.applicants.properties.identityNumber?.foreign;
          if (foreign === "RESIDENCE_PERMIT") {
            return [this.isRequired, this.onlyEnNum10, this.sameId];
          }
          return [this.isRequired, this.onlyEnNumGreaterThan6, this.sameId];
        }
      }
      return [this.isRequired, this.onlyEnNum, this.sameId];
    },
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
    }),
    detectCustomFieldDiff() {
      this.customDiff = this.customFields.some(
        (v) => v.value !== this.form[v.name]
      );
    },
    customFieldChange(name, value) {
      this.form[name] = value;
      this.$forceUpdate();
      this.detectCustomFieldDiff();
    },
    toASCII(str) {
      /**
       * 轉半形字元
       */
      return str
        .replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        })
        .replace(/\u3000/g, " ");
    },
    keyupSetting() {
      this.form.identityNumber = this.toASCII(
        this.form.identityNumber
      ).toUpperCase();
    },
    updateIdentityNumber(v, e) {
      if (window.event.inputType === "insertCompositionText") return;
      this.form.identityNumber = this.toASCII(
        this.form.identityNumber
      ).toUpperCase();
    },
    onlyEnChWord(v) {
      return (
        /^[\s\u4e00-\u9fa5_a-zA-Z]+$/.test(v) ||
        this.$t("applicant_validation_en_ch_word")
      );
    },
    onlyEnNum(v) {
      return /^[a-zA-Z0-9]+$/.test(v) || this.$t("applicant_validation_en_num");
    },
    idNumberValid(value) {
      var reg = /^[A-Z]{1}[1-2]{1}[0-9]{8}$/; //身份證的正規表示式;
      // 小寫可過
      if (!value || value === "") return this.$t("id_number_validation");
      if (reg.test(value.toUpperCase())) {
        var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"; //把 A 取代成 10,把 B 取代成 11...的作法
        var ct = [
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "34",
          "18",
          "19",
          "20",
          "21",
          "22",
          "35",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "32",
          "30",
          "31",
          "33",
        ];

        var i = s.indexOf(value.toUpperCase().charAt(0));
        var tempuserid = ct[i] + value.substr(1, 9); //若此身份證號若是A123456789=>10123456789
        var num = tempuserid.charAt(0) * 1;

        for (i = 1; i <= 9; i++) {
          num = num + tempuserid.charAt(i) * (10 - i);
        }

        num += tempuserid.charAt(10) * 1;
        return num % 10 === 0 || this.$t("id_number_validation");
      }
      return this.$t("id_number_validation");
    },
    isRequired(v) {
      return !!v || this.$t("form_required");
    },
    onlyChWord(v) {
      return (
        /^[\u4e00-\u9fa5]+$/.test(v) || this.$t("applicant_validation_ch_name")
      );
    },
    onlyEnWord(v) {
      return /^[a-zA-Z\s]+$/.test(v) || this.$t("applicant_validation_en_name");
    },
    onlyEnNumSpace(v) {
      return (
        /^[a-zA-Z0-9\s]+$/.test(v) ||
        this.$t("applicant_validation_en_num_space")
      );
    },
    onlyEnNumGreaterThan6(v) {
      return (
        /^[a-zA-Z0-9]{7,}$/.test(v) ||
        this.$t("applicant_validation_en_num_gt6")
      );
    },
    onlyEnNum10(v) {
      return (
        /^[a-zA-Z0-9]{10}$/.test(v) || this.$t("applicant_validation_en_num_10")
      );
    },
    residencePermitValid(value) {
      if (!value || value === "")
        return this.$t("applicant_validation_residence_permit");
      const id = value.toUpperCase();

      // 1. 舊式：2 碼英文 + 8 碼數字
      if (/^[A-Z][A-D]\d{8}$/.test(id)) {
        const s = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const ct = [
          10, 11, 12, 13, 14, 15, 16, 17, 34, 18, 19, 20, 21, 22, 35, 23, 24,
          25, 26, 27, 28, 29, 32, 30, 31, 33,
        ];
        let code1 = ct[s.indexOf(id[0])];
        let n1 = Math.floor(code1 / 10);
        let n2 = code1 % 10;
        let code2 = ct[s.indexOf(id[1])] % 10;
        let sum = n1 * 1 + n2 * 9 + code2 * 8;
        for (let i = 2; i < 9; i++) {
          sum += parseInt(id[i]) * (8 - i);
        }
        sum += parseInt(id[9]) * 1;
        return (
          sum % 10 === 0 || this.$t("applicant_validation_residence_permit")
        );
      }

      // 2. 新式：1 碼英文 + 9 碼數字 (其中第二碼為 8 或 9)
      if (/^[A-Z][89]\d{8}$/.test(id)) {
        const s = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const ct = [
          10, 11, 12, 13, 14, 15, 16, 17, 34, 18, 19, 20, 21, 22, 35, 23, 24,
          25, 26, 27, 28, 29, 32, 30, 31, 33,
        ];
        const first = ct[s.indexOf(id[0])];
        const n1 = Math.floor(first / 10);
        const n2 = first % 10;

        const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
        const nums = [n1, n2, ...id.slice(1).split("").map(Number)];

        let sum = 0;
        for (let i = 0; i < 11; i++) {
          sum += nums[i] * weights[i];
        }
        return (
          sum % 10 === 0 || this.$t("applicant_validation_residence_permit")
        );
      }
      return this.$t("applicant_validation_residence_permit");
    },
    initNationalityType() {
      if (this.session?.applicants?.properties?.nationality) {
        this.nationalityType = this.form.nationality || null;
      } else {
        this.nationalityType = null;
      }
    },
    clearNationalityDependentFields() {
      NATIONALITY_DEPENDENT_FIELDS.forEach((field) => {
        this.form[field] = "";
      });
    },
    handleNationalityChange() {
      this.clearNationalityDependentFields();
      this.$nextTick(() => this.validateAllForms());
    },
    getCountryLabel(code) {
      const normalized = normalizeNationalityValue(code);
      const match = countryList.find((c) => c.iso2 === normalized);
      return match ? match.name : code;
    },
    sameId(v) {
      const filter = this.applicants.filter(
        (a) => a.identityNumber === v && a.index !== this.applicant.index
      );
      return (
        !filter.length ||
        this.$t("applicant_validation_identity_number_duplicate")
      );
    },
    isNumber(v) {
      return /^[0-9]{1,2}$/.test(v) || this.$t("applicant_validation_number");
    },
    isEmail(v) {
      return /.+@.+\..+/.test(v) || this.$t("form_email_invalid_text");
    },
    doCloseConfirm() {
      const formData = { ...this.form };

      if (this.isEdit && (this.hasDiff || this.hasEmpty)) {
        this.$emit("beforeClose", { ...formData, isComplete: false });
        return;
      }

      const allValid = this.formValid;

      if (!this.isEdit && (!formData.isComplete || !allValid)) {
        const form = createEmptyForm();
        delete form.tempphoneCountry;
        delete form.tempphoneNumber;
        delete form.tempemergencyContactPhoneCountry;
        delete form.tempemergencyContactPhoneNumber;
        if (this.customFields.length) {
          this.customFields.forEach((v) => {
            v.value = "";
            form[v.name] = "";
          });
        }
        this.$emit("beforeClose", { ...form });
        return;
      }

      this.$emit("close", { ...formData });
    },
    phoneNumberUpdate(name, obj) {
      if (name === "tempphoneNumber") {
        // this.form.tempphoneCountry = `+${obj?.countryCallingCode}`;
        this.form.tempphoneNumber = obj?.phoneNumber || "";
        this.form.phoneNumber = obj?.formatInternational || "";
      } else {
        // this.form.tempemergencyContactPhoneCountry = `+${obj?.countryCallingCode}`;
        this.form.tempemergencyContactPhoneNumber = obj?.phoneNumber || "";
        this.form.emergencyContactPhoneNumber = obj?.formatInternational || "";
      }
    },
    setForm(newVal) {
      for (var i in newVal) {
        let val = newVal[i];
        if (i.indexOf("custom") > -1) {
          this.$set(this.form, i, val);
          this.customFields.forEach((v) => {
            if (v.name === i) v.value = val;
          });
        } else {
          this.form[i] = val;
        }
      }
    },
    anchorToAlert(elem) {
      window.event.preventDefault();
      let input =
        elem.tagName === "INPUT"
          ? elem
          : elem.querySelector("input") || elem.querySelector("select");
      if (["phoneNumber", "emergencyContactPhoneNumber"].includes(elem.id))
        input = elem.querySelector(".input-tel__input");
      document.querySelector("#applicant-dialog").parentElement.scrollTo({
        left: 0,
        top: elem.offsetTop - 100,
        behavior: "smooth",
      });

      input.focus();
    },
    async submit() {
      const formsValid = this.validateAllForms();
      const invalidField = this.findFirstInvalidRequiredField();

      if (!formsValid || invalidField) {
        if (invalidField) {
          const elem = document.querySelector(`#${invalidField}`);
          if (elem) {
            this.anchorToAlert(elem);
          }
        }
        return;
      }

      if (
        // !this.isEdit && this.form.identityNumber === this.applicant.identityNumber ||
        this.isEdit &&
        !this.hasEditable
      ) {
        this.$emit("close", {
          ...this.form,
          index: this.applicant.index,
          ticketName: this.applicant.ticketName,
          isComplete: true,
        });
        return;
      }
      if (this.isEdit && this.hasEditable) {
        this.$emit("submit", {
          data: {
            ...this.form,
            age: Number(this.form.age),
          },
          index: this.applicant.index,
          ticketName: this.applicant.ticketName,
          isComplete: true,
        });
      } else {
        const formData = {
          ...this.form,
          age: Number(this.form.age),
        };
        const fieldsToStrip = [
          "ticket",
          "index",
          "displayIndex",
          "isComplete",
          "tempemergencyContactPhoneNumber",
          "tempemergencyContactPhoneCountry",
          "tempphoneNumber",
          "tempphoneCountry",
          "ticketName",
        ];
        fieldsToStrip.forEach((key) => delete formData[key]);

        const updateParams = {
          orderId: this.reserveResponse.orderId,
          index: this.applicant.index,
          newApplicant: { ...formData },
        };
        const { data: updateResponse } = await TM.updateApplicants(
          updateParams
        );

        if (updateResponse.errCode === "00") {
          // debugger
          this.$emit("close", {
            ...formData,
            displayIndex: this.applicant.displayIndex,
            index: this.applicant.index,
            ticketName: this.applicant.ticketName,
            isComplete: true,
          });
        } else {
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t(
                updateResponse.errCode === "101"
                  ? "error_with_no_outstanding_order"
                  : "duplicate_id_number"
              )}</div>
            </div>`,
          });
          this.form.identityNumber = "";
        }
      }
    },
    emitUpdateDate(date) {
      this.form.birthday = date;
    },
    resetCustomState() {
      Object.keys(this.form)
        .filter((k) => k.indexOf("custom") > -1)
        .forEach((k) => this.$delete(this.form, k));
      this.customFields = [];
      this.customDiff = false;
    },
    initCustomFields(sourceData = {}) {
      const applicant = normalizeApplicant(sourceData || this.applicant);
      this.customFields = [];

      Object.keys(this.session.applicants.properties).forEach((key) => {
        if (key.indexOf("custom") > -1) {
          const name = key.split("_");
          const val = applicant[key] || "";
          this.$set(this.form, key, val);
          this.customFields.push({
            fullName: key,
            index: Number(name[0].replace("custom", "")),
            ...this.session.applicants.properties[key],
            label: name[1],
            name: key,
            value: val,
          });
        }
      });

      this.customFields = this.customFields.sort((a, b) => a.index - b.index);
      this.appliData = {
        ...this.appliData,
        ...applicant,
        ticket: applicant.ticketName,
        ticketName: applicant.ticketName,
        index: applicant.index,
      };
    },
    isFieldVisible(key) {
      const props = this.session?.applicants?.properties || {};
      if (!props[key]) return false;

      const detailKeys = [
        "identityName",
        "identityNumber",
        "firstName",
        "lastName",
        "birthday",
        "age",
        "gender",
        "phoneNumber",
        "address",
        "email",
      ];

      if (
        key !== "nationality" &&
        detailKeys.includes(key) &&
        props.nationality &&
        !this.shouldShowApplicantDetailFields
      ) {
        return false;
      }

      return true;
    },
    isFieldValueInvalid(key) {
      if (["phoneNumber", "emergencyContactPhoneNumber"].includes(key)) {
        return !this.form[`temp${key}`] || this.form[`temp${key}`] === "";
      }

      const value = this.form[key];
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value === "" || value === null || typeof value === "undefined";
    },
    validateAllForms() {
      const formRef = this.$refs.applicantForm;
      if (!formRef || typeof formRef.validate !== "function") return true;
      return formRef.validate();
    },
    findFirstInvalidRequiredField() {
      return this.requiredFieldKeys.find((key) =>
        this.isFieldValueInvalid(key)
      );
    },
  },
  mounted() {
    if (this.$refs.idNumberInput) {
      const $elm = this.$refs.idNumberInput.$el.querySelector("input");
      if ($elm) {
        $elm.addEventListener("input", (e) => {
          e.preventDefault();
          this.form.identityNumber = e.target.value.toUpperCase();
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-date-picker-table {
    .v-btn.v-date-picker-table__current {
      border: 0 !important;
      padding: 0 !important;
      background: none !important;

      &::before,
      &::after {
        display: none !important;
      }
    }
  }

  .v-input--radio-group__input {
    flex-wrap: wrap;

    legend {
      width: 100%;
      margin-bottom: 8px;
    }
  }

  .is-phone-lock {
    float: right;
    margin-top: -29px;
    opacity: 0.6;
  }

  .vue-phone-number-input {
    .country-selector__label {
      font-size: 12px;
    }

    .dots-text {
      color: black;
    }

    .input-tel.is-disabled .input-tel__input,
    .country-selector.is-disabled .country-selector__input {
      background: none;
    }

    label {
      font-size: 16px;
    }

    .country-selector__input,
    .input-tel__input {
      border: 0;
    }

    .input-tel__label,
    .country-selector__label,
    .country-selector__country-flag {
      left: 0;
    }

    .country-selector__country-flag {
      bottom: 26px;
    }

    .country-selector__input {
      padding-left: 24px;
    }

    input {
      font-size: 16px;
      border: 0 !important;
      border-bottom: 1px solid #9a9a9a !important;
      box-shadow: none;
      padding: 8px 0;
      outline: none !important;
      border-radius: 0 !important;
    }

    .country-selector,
    .input-tel {
      &.is-valid .input-tel__label,
      &.is-valid .country-selector__label {
        color: rgba(0, 0, 0, 0.6) !important;
      }

      &.has-error:not(.is-valid) .input-tel__input {
        border-color: #ff4500 !important;
      }

      &.has-hint .input-tel__label,
      &.has-value .input-tel__label,
      &.has-hint .country-selector__label,
      &.has-value .country-selector__label {
        transform: translateY(-8px);
      }

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        display: block;
        bottom: -1px;
        margin: auto;
        width: 0px;
        height: 2px;
        background: black;
        transition: all 0.3s ease;
      }

      &.is-focused {
        border: 0;
        outline: none;

        input {
          border: 0 !important;
          border-bottom: 1px solid #9a9a9a !important;
          box-shadow: none !important;
        }

        .input-tel__label,
        .country-selector__label {
          color: $primary-1;
        }

        &::after {
          background-color: $primary-1;
          width: 100%;
        }
      }
    }

    &.error--text {
      .country-selector,
      .input-tel {
        .input-tel__label {
          color: #ff0032 !important;
        }
      }
    }
  }

  .expansion-container {
    display: block !important;
    width: 100%;
    max-width: 750px;
    margin: 0 auto 80px;
  }

  .v-dialog {
    position: relative;
    max-width: 720px !important;

    .expansion-action {
      text-align: right;
    }

    .applicant-sections {
      display: block;
      border-radius: 4px;
      overflow: visible;
      // box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.15);
      background: #fff;
      padding: 20px 24px 8px;
    }

    .applicant-form-block .row .col {
      padding-top: 8px;
      padding-bottom: 8px;
    }
    .applicant-form-block + .applicant-form-block {
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      margin-top: 12px;
      padding-top: 20px;
    }

    .applicant-subtitle {
      font-weight: 600;
      margin-bottom: 8px;
    }

    .country-selector__list {
      max-height: 180px !important;
    }

    @media screen and (max-width: 600px) {
      width: 100% !important;
      height: 100%;
      max-height: 100%;
      margin: 0;
      -webkit-overflow-scrolling: touch;

      > div {
        height: 100%;
        padding-left: 15px !important;
        padding-right: 15px !important;
        padding-top: 56px !important;

        .applicant-sections {
          padding: 12px 15px 8px;
        }

        .applicant-form-block + .applicant-form-block {
          margin-top: 8px;
          padding-top: 16px;
        }

        .applicant-form-block {
          .input-tel__label {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .container {
            padding: 0 !important;
          }

          .v-input--selection-controls {
            margin-top: 0;
          }
        }

        .text-title {
          font-size: 1rem;
        }

        .expansion-action {
          text-align: center;
          margin-top: 24px;
        }

        .expansion-container {
          margin-left: -15px;
          margin-right: -15px;
          padding-top: 16px;
          width: calc(100% + 30px) !important;
        }
      }
    }

    .close {
      position: absolute;
      font-size: 32px;
      width: 48px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      right: 0;
      top: 0;
    }
  }

  .vue-country-list-wrap {
    min-width: 120px;
  }

  .vue-country-list-wrap .vue-country-list {
    list-style: none;
    padding: 0;

    @media screen and (max-width: 600px) {
      .vue-country-item .vue-country-name {
        display: none;
      }
    }
  }
}
</style>
